/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popGameWinPrompt.vue?vue&type=template&id=5ec317cc&scoped=true"
import script from "./popGameWinPrompt.vue?vue&type=script&lang=js"
export * from "./popGameWinPrompt.vue?vue&type=script&lang=js"
import style0 from "./popGameWinPrompt.vue?vue&type=style&index=0&id=5ec317cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec317cc",
  null
  
)

export default component.exports